import { Gem, BadgeCheck, Layers, Gift, HeartHandshake } from "lucide-react";
import { FastReveal } from "@/components/FastReveal";
import { useLanguage } from "@/context/LanguageContext";

const icons = [Gem, BadgeCheck, Layers, Gift, HeartHandshake];

export default function TrustBar() {
  const { t } = useLanguage();
  return (
    <section data-testid="trust-bar" className="border-b border-[#eee] bg-white">
      <div className="fade-edges mx-auto flex max-w-7xl gap-8 overflow-x-auto px-5 py-7 lg:grid lg:grid-cols-5 lg:gap-6 lg:px-10">
        {t.trust.map((label, i) => {
          const Icon = icons[i] || Gem;
          return (
            <FastReveal
              key={i}
              delay={0.06 * i}
              y={12}
              data-testid={`trust-item-${i}`}
              className="flex min-w-[150px] flex-col items-center gap-2 text-center lg:min-w-0"
            >
              <Icon className="h-6 w-6 text-[#111]" strokeWidth={1.3} />
              <span className="font-body text-xs font-medium tracking-wide text-[#333]">{label}</span>
            </FastReveal>
          );
        })}
      </div>
    </section>
  );
}
